"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var RotateRight = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M22.0024111,11.992017 C22.0024111,11.444032 21.5564654,11 20.999651,11 L12.0051713,11 C11.4536844,11 11.0024111,11.4501474 11.0024111,11.992017 L11.0024111,19.007983 C11.0024111,19.555968 11.4483569,20 12.0051713,20 L20.999651,20 C21.5511379,20 22.0024111,19.5498526 22.0024111,19.007983 L22.0024111,11.992017 Z M23.0024111,11.992017 L23.0024111,19.007983 C23.0024111,20.0998238 22.1057449,21 20.999651,21 L12.0051713,21 C10.8959538,21 10.0024111,20.1081436 10.0024111,19.007983 L10.0024111,11.992017 C10.0024111,10.9001762 10.8990774,10 12.0051713,10 L20.999651,10 C22.1088685,10 23.0024111,10.8918564 23.0024111,11.992017 Z M3.16056106,13.6 C3.57739211,9.90965564 5.88689591,6.72160742 9.225107,5.13927495 L9.35250297,5.07888848 L10.6407718,6.36715729 L14.0024111,3.00551794 C13.9287379,3.00181976 13.859966,3 13.7907718,3 C7.71560238,3 2.66585557,7.6108387 2.06,13.6 L3.16056106,13.6 Z" })));
};
RotateRight.displayName = 'RotateRight';
exports.default = RotateRight;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=RotateRight.js.map